import Constants = require("../Constants");
import Endpoints = require("../Endpoints");

import type { RequestHandler as RH } from "../RequestHandler";

import type {
	RESTDeleteAPIGuildEmojiResult,
	RESTDeleteAPIGuildStickerResult,
	RESTGetAPIApplicationEmojisResult,
	RESTGetAPIApplicationEmojiResult,
	RESTGetAPIGuildEmojiResult,
	RESTGetAPIGuildEmojisResult,
	RESTGetAPIGuildStickerResult,
	RESTGetAPIGuildStickersResult,
	RESTGetAPIStickerResult,
	RESTPatchAPIGuildEmojiJSONBody,
	RESTPatchAPIGuildEmojiResult,
	RESTPatchAPIGuildStickerJSONBody,
	RESTPatchAPIGuildStickerResult,
	RESTPostAPIGuildEmojiJSONBody,
	RESTPostAPIGuildEmojiResult,
	RESTPostAPIGuildStickerFormDataBody,
	RESTPostAPIGuildStickerResult,
	RESTPostAPIApplicationEmojiResult,
	RESTPostAPIApplicationEmojiJSONBody,
	RESTPatchAPIApplicationEmojiJSONBody,
	RESTPatchAPIApplicationEmojiResult,
	RESTDeleteAPIApplicationEmojiResult
} from "discord-api-types/v10";

import type { Blob } from "buffer";

import type { Readable } from "stream";
import type { ReadableStream } from "stream/web";





class AssetsMethods {








	public constructor(public requestHandler: RH) {}











	public async getGuildEmojis(guildId: string): Promise<RESTGetAPIGuildEmojisResult> {
		return this.requestHandler.request(Endpoints.GUILD_EMOJIS(guildId), {}, "get", "json");
	}












	public async getGuildEmoji(guildId: string, emojiId: string): Promise<RESTGetAPIGuildEmojiResult> {
		return this.requestHandler.request(Endpoints.GUILD_EMOJI(guildId, emojiId), {}, "get", "json");
	}






















	public async createGuildEmoji(guildId: string, data: RESTPostAPIGuildEmojiJSONBody & { reason?: string; }): Promise<RESTPostAPIGuildEmojiResult> {
		return this.requestHandler.request(Endpoints.GUILD_EMOJIS(guildId), {}, "post", "json", data);
	}





















	public async updateGuildEmoji(guildId: string, emojiId: string, data: RESTPatchAPIGuildEmojiJSONBody & { reason?: string; }): Promise<RESTPatchAPIGuildEmojiResult> {
		return this.requestHandler.request(Endpoints.GUILD_EMOJI(guildId, emojiId), {}, "patch", "json", data);
	}


















	public async deleteGuildEmoji(guildId: string, emojiId: string, reason?: string): Promise<RESTDeleteAPIGuildEmojiResult> {
		return this.requestHandler.request(Endpoints.GUILD_EMOJI(guildId, emojiId), {}, "delete", "json", { reason }) as RESTDeleteAPIGuildEmojiResult;
	}











	public async getSticker(stickerId: string): Promise<RESTGetAPIStickerResult> {
		return this.requestHandler.request(Endpoints.STICKER(stickerId), {}, "get", "json");
	}















	public async getGuildStickers(guildId: string): Promise<RESTGetAPIGuildStickersResult> {
		return this.requestHandler.request(Endpoints.GUILD_STICKERS(guildId), {}, "get", "json");
	}
















	public async getGuildSticker(guildId: string, stickerId: string): Promise<RESTGetAPIGuildStickerResult> {
		return this.requestHandler.request(Endpoints.GUILD_STICKER(guildId, stickerId), {}, "get", "json");
	}




























	public async createGuildSticker(guildId: string, data: RESTPostAPIGuildStickerFormDataBody & { file: Buffer | Blob | File | Readable | ReadableStream; reason?: string; }): Promise<RESTPostAPIGuildStickerResult> {
		const form = new FormData();
		const reason = data.reason;
		if (data.reason) delete data.reason;

		for (const key of Object.keys(data)) {
			await Constants.standardAddToFormHandler(form, key, data[key]);
		}

		return this.requestHandler.request(Endpoints.GUILD_STICKERS(guildId), {}, "post", "multipart", form, reason ? { "X-Audit-Log-Reason": reason } : undefined);
	}


















	public async updateGuildSticker(guildId: string, stickerId: string, data: RESTPatchAPIGuildStickerJSONBody & { reason?: string; }): Promise<RESTPatchAPIGuildStickerResult> {
		return this.requestHandler.request(Endpoints.GUILD_STICKER(guildId, stickerId), {}, "patch", "json", data);
	}


















	public async deleteGuildSticker(guildId: string, stickerId: string, reason?: string): Promise<RESTDeleteAPIGuildStickerResult> {
		return this.requestHandler.request(Endpoints.GUILD_STICKER(guildId, stickerId), {}, "delete", "json", { reason }) as RESTDeleteAPIGuildStickerResult;
	}












	public async getAppEmojis(appId: string): Promise<RESTGetAPIApplicationEmojisResult> {
		return this.requestHandler.request(Endpoints.APPLICATION_EMOJIS(appId), {}, "get", "json");
	}













	public async getAppEmoji(appId: string, emojiId: string): Promise<RESTGetAPIApplicationEmojiResult> {
		return this.requestHandler.request(Endpoints.APPLICATION_EMOJI(appId, emojiId), {}, "get", "json");
	}


















	public async createAppEmoji(appId: string, data: RESTPostAPIApplicationEmojiJSONBody): Promise<RESTPostAPIApplicationEmojiResult> {
		return this.requestHandler.request(Endpoints.APPLICATION_EMOJIS(appId), {}, "post", "json", data);
	}

















	public async updateAppEmoji(appId: string, emojiId: string, data: RESTPatchAPIApplicationEmojiJSONBody): Promise<RESTPatchAPIApplicationEmojiResult> {
		return this.requestHandler.request(Endpoints.APPLICATION_EMOJI(appId, emojiId), {}, "patch", "json", data);
	}














	public async deleteAppEmoji(appId: string, emojiId: string): Promise<RESTDeleteAPIApplicationEmojiResult> {
		return this.requestHandler.request(Endpoints.APPLICATION_EMOJI(appId, emojiId), {}, "delete", "json") as Promise<RESTDeleteAPIApplicationEmojiResult>;
	}
}

export = AssetsMethods;
